export default __webpack_public_path__ + "static/media/Regenwurm.1c6c982b.webp";